<template>
    <div class="box_gallerry">
        <div class="box_gallerry_content">
            <div class="woocommerce-product-gallery splide" :data-total_image="`${totalImage}`" style="opacity: 1;">
                <div class="product-imgs woocommerce-product-gallery__wrapper splide__track">
                    <div id="gallery" ref="galleryImage" class="product-image-wrapper gallery splide__list" :class="totalImage > 3 ? 'product-image-two-col' : 'product-image-one-col'">
                        <template v-for="(item, index) in data" :key="index">
                            <div class="woocommerce-product-gallery__image splide__slide" v-if="item.type === 'image'" :class="{ 'last-odd-class': index === data.length - 1 && data.length % 2 !== 0 }">
                                <a :href="`${baseUrl}api/wp-content/uploads/${item.zoomsrc}`" data-pswp-width="1000" data-pswp-height="1000">
                                    <template v-if="isZoomable[index] && isDesktop">
                                        <VueInnerImageZoom
                                            v-if="item.zoomsrc"
                                            :src="`${baseUrl}api/wp-content/uploads/${item.zoomsrc}`"
                                            :zoomScale="1"
                                            :zoomType="'hover'"
                                            :alt="item.alt || `${props.name || ''}${props.material ? ' in ' + props.material : ''} - SK Jewellery`"
                                        />
                                    </template>
                                    <template v-else>
                                        <img :src="`${baseUrl}api/wp-content/uploads/${item.zoomsrc}`" :alt="item.alt || `${props.name || ''}${props.material ? ' in ' + props.material : ''} - SK Jewellery`" />
                                    </template>
                                </a>
                            </div>
                            <div v-else data-thumb="" class="woocommerce-product-gallery__image woocommerce-product-gallery__video splide__slide" :class="{ 'last-odd-class': index === data.length - 1 && data.length % 2 !== 0 }">
                                <video poster="" class="video_gallery video_lazy lazy-img-dev" :id="'video_gallery_' + (item.id || index)" :src="`${baseUrl}api/wp-content/uploads/${item.woocommerce_single}`"  @click="showPopupVideo(item.woocommerce_single)"  muted
                                playsinline loop
                                autoplay>
                                    <source :src="`${baseUrl}api/wp-content/uploads/${item.woocommerce_single}`" type="video/mp4">
                                </video>
                            </div>
                        </template>
                    </div>
                    <div class="custom_zomm_mb">
                        <img src="https://www.skjewellery.com.my/api/wp-content/uploads/2024/12/zoom_icon.svg" alt="icon zoom">
                    </div>
                    <div v-if="props.isPre0rder" class="pre-order-badge-wrapper" data-tag="59">
                        <div class="pre-order-badge">
                            Preorder
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
        v-if="isPopupGalleryVisible"
        class="popup-overlay-video-gallery"
        @click="closePopupVideo">
        <div class="popup-content-gallery">
            <video
                controls autoplay
                :src="popupVideoUrl"
                class="popup-video-gallery">
                <source :src="popupVideoUrl" type="video/mp4">
            </video>
        </div>
        <button class="close-btn" @click="closePopupVideo">
            <svg xmlns="http://www.w3.org/2000/svg" class="button-svg" viewBox="0 0 24 24"><path fill="currentColor" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"/></svg>
        </button>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_gallery.scss";
</style>

<script setup lang="ts">
    import Splide from "@splidejs/splide";
    import { useVueInnerImageZoom } from '~/composables/useVueInnerImageZoom';
    import { usePhotoSwipe } from '~/composables/usePhotoSwipe';
    const VueInnerImageZoom = useVueInnerImageZoom();
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const isDesktop = ref(true);

    const props = defineProps(["data", "isPre0rder", "maxHeight", "material", "name"]);
    const data = computed(() => props.data);
    const totalImage = ref(data.value.length);
    const maxHeight = computed(() => props.maxHeight);
    const { init } = usePhotoSwipe('#gallery');
    const galleryImage = ref<HTMLElement | null>(null);

    const isZoomable = ref<boolean[]>(new Array(data.value.length).fill(false));

    const checkImageZoomable = async (index: number): Promise<void> => {
        try {
            const isZoomableForImage = await isImageZoomable(index);
            isZoomable.value[index] = isZoomableForImage;
        } catch {
            isZoomable.value[index] = false;
        }
    };

    const isImageZoomable = (index: number): Promise<boolean> => {
        return new Promise((resolve) => {
            const item = data.value[index];
            if (!item || item.type !== 'image' || !item.zoomsrc) {
                resolve(false);
                return;
            }
            const containerWidth = galleryImage.value?.offsetWidth;

            if (!containerWidth) {
                resolve(false);
                return;
            }

            const img = new Image();
            img.src = `${baseUrl}api/wp-content/uploads/${item.zoomsrc}`;

            img.onload = () => {
                resolve(img.width >= containerWidth);
            };

            img.onerror = () => {
                resolve(false);
            };
        });
    };

    const isPopupGalleryVisible = ref(false);
    const popupVideoUrl = ref('');
    const showPopupVideo = (videoUrl: string) => {
        popupVideoUrl.value = `${baseUrl}api/wp-content/uploads/${videoUrl}`;
        isPopupGalleryVisible.value = true;
    };

    const closePopupVideo = () => {
        isPopupGalleryVisible.value = false;
        popupVideoUrl.value = '';
    };
    const addZoomAfterStyle = () => {
        const widthScreen = window.innerWidth;
        const set_top_icon = (widthScreen - 100) / 2 - 20;
        const style = document.createElement("style");
        style.type = "text/css";
        style.innerHTML = `
            .active_zoom::after {
                display: block;
                content: "";
                background: url(https://www.skjewellery.com/api/wp-content/uploads/2024/12/Pinch-with-overlay.png);
                position: absolute;
                width: 100px;
                height: 100px;
                top: ${set_top_icon}px;
                left: ${set_top_icon}px;
                z-index: 999;
                opacity: 1;
                transition: opacity 1s ease-in-out;
            }
            .active_zoom.fade-out::after {
                opacity: 0;
            }
        `;
        document.head.appendChild(style);
    };

    const appentBtnClick = () => {
        if (window.innerWidth < 768) {
            const productImgs = document.querySelectorAll(".box_gallerry_content .product-imgs");

            if (productImgs.length > 0) {
            productImgs.forEach((imgContainer) => {

                const zoomBtn = document.querySelector(".custom_zomm_mb");
                if(zoomBtn) {
                    zoomBtn.addEventListener("click", function () {
                        const activeElement = document.querySelector<HTMLElement>(
                        ".woocommerce-product-gallery__image.is-active a, .woocommerce-product-gallery__image.is-active video"
                        );
                        if (activeElement) {
                            // if (activeElement.tagName.toLowerCase() === "a") {
                            //     activeElement.click();
                            // } else if (activeElement.tagName.toLowerCase() === "video") {
                            //     activeElement.click();
                            // }
                            activeElement.click();
                        } else {
                            console.error("No active image or video found.");
                        }
                        // const activeImage = document.querySelector(
                        //     ".woocommerce-product-gallery__image.is-active a"
                        // );
                        // if (activeImage) {
                        //     activeImage.click();
                        // } else {
                        //     console.error("No active image found with <a> tag.");
                        // }

                        const intervalCheckZoom = setInterval(() => {
                            const modalShowImage = document.querySelector(".pswp--open .pswp__scroll-wrap");
                            if (modalShowImage && !modalShowImage.classList.contains("active_modal")) {
                            modalShowImage.classList.add("active_modal");
                            }

                            const modalImgZoom = document.querySelectorAll(
                            ".pswp--open .pswp__scroll-wrap .pswp__item .pswp__zoom-wrap"
                            );

                            if (modalImgZoom.length > 0) {
                            clearInterval(intervalCheckZoom);
                            modalImgZoom.forEach((zoomElement) => {
                                if (!zoomElement.classList.contains("active_zoom")) {
                                zoomElement.classList.add("active_zoom");
                                }
                            });

                            setTimeout(() => {
                                modalImgZoom.forEach((zoomElement) => {
                                zoomElement.classList.add("fade-out");
                                setTimeout(() => {
                                    zoomElement.classList.remove("active_zoom", "fade-out");
                                }, 700);
                                });
                            }, 2000);
                        }
                    }, 100);
                });
                }

            });
            } else {
                console.error('No elements with class "product-imgs" found.');
            }
        }
    };



    onMounted(() => {
        data.value.forEach((_:any, index:number) => {
            checkImageZoomable(index);
        });

        init();

        if (window.innerWidth < 768) {
            isDesktop.value = false;
            var gallerymb = new Splide(".woocommerce-product-gallery", {
                perMove: 1,
                pagination: true,
                perPage: 1,
                fixedWidth: '100',
                arrows: false,
                loop: true,
            });
            gallerymb.mount();
        }
        addZoomAfterStyle();
        appentBtnClick();
    });
</script>
